import { useEffect, useState } from 'react'
import { message } from 'antd'
import { fetchLessonLearnedData } from 'src/Services/MentorServices/LessonLearnedService'

const useLessonLearned = (token) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [total, setTotal] = useState(0)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const response = await fetchLessonLearnedData(token, {
          pageNumber: page,
          pageSize,
        })
        const formattedData = response.items.map((item, index) => ({
          key: index.toString(),
          phaseId: item.phaseId,
          // api-dev2: lesson-learned own id may be `id` (fallback to lessonLearnedId).
          lessonLearnedId: item.id ?? item.lessonLearnedId,
          projectId: item.projectId,
          projectName: item.projectName,
          groupName: item.groupName,
          completedPhase: item.phaseName,
        }))
        setData(formattedData)
        setTotal(response.totalCount)
      } catch (error) {
        message.error('Failed to fetch data')
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [token, page, pageSize])

  return { data, loading, page, pageSize, total, setPage, setPageSize }
}

export default useLessonLearned
